export const OCCASION_TAXONOMY_VERSION = "occasion.v1" as const;

const OCCASIONS = {
  birthday: { label: "Birthday", emoji: "🎂" },
  trip: { label: "Trip or holiday", emoji: "✈️" },
  old_photos: { label: "Old photos to life", emoji: "📷" },
  group: { label: "Celebrating a group", emoji: "😂" },
  big_moment: { label: "Big life moments", emoji: "⭐" },
  pet: { label: "Pet stories", emoji: "🐶" },
  romance: { label: "Romance", emoji: "❤️" },
  news: { label: "News Bulletin", emoji: "📺" },
  musical: { label: "Musical", emoji: "🎵" },
  real_estate: { label: "Real Estate", emoji: "🏠" },
  other: { label: "Something else", emoji: "💬" },
} as const;

export type OccasionKey = keyof typeof OCCASIONS;

const CALLBACK_TO_KEY: Record<string, OccasionKey> = {
  category_birthday: "birthday",
  category_trip: "trip",
  category_old_photos: "old_photos",
  category_group: "group",
  category_big_moment: "big_moment",
  category_pet: "pet",
  category_romance: "romance",
  category_news: "news",
  category_musical: "musical",
  category_real_estate: "real_estate",
  category_other: "other",
};

export type OccasionDisplay =
  | {
      key: OccasionKey;
      label: string;
      emoji: string;
      state: "classified";
    }
  | {
      key: "unknown";
      label: "Unknown occasion";
      emoji: "❓";
      state: "unknown";
    };

function normalizedKey(value?: string | null): string | null {
  if (!value) return null;
  const normalized = value.trim().toLowerCase();
  return CALLBACK_TO_KEY[normalized] ?? normalized;
}

export function resolveOccasion(
  occasionKey?: string | null,
  legacyCategory?: string | null,
): OccasionDisplay | null {
  const key = normalizedKey(occasionKey) ?? normalizedKey(legacyCategory);
  if (!key) return null;
  if (key === "unknown") {
    return {
      key: "unknown",
      label: "Unknown occasion",
      emoji: "❓",
      state: "unknown",
    };
  }
  if (!(key in OCCASIONS)) return null;
  const typedKey = key as OccasionKey;
  return {
    key: typedKey,
    ...OCCASIONS[typedKey],
    state: "classified",
  };
}

export function occasionBadgeLabel(
  occasionKey?: string | null,
  legacyCategory?: string | null,
): string | null {
  const occasion = resolveOccasion(occasionKey, legacyCategory);
  return occasion ? `${occasion.emoji} ${occasion.label}` : null;
}
